export enum ActionType {
  Undefined = 'Undefined',
  SmartIdentifyUploadAndAnalyzeSafetyDataSheet = 'SmartIdentifyUploadAndAnalyzeSafetyDataSheet',
  SmartIdentifyAddProductToMyArticles = 'SmartIdentifyAddProductToMyArticles',
  SmartIdentifyAnalyzeTransportationRequirements = 'SmartIdentifyAnalyzeTransportationRequirements',
  // [ActionTypeAggregation(SmartIdentifyUploadAndAnalyzeSafetyDataSheet)]
  // [ActionTypeAggregation(SmartIdentifyAddProductToMyArticles)]
  // [ActionTypeAggregation(SmartIdentifyAnalyzeTransportationRequirements)]
  SmartIdentifyComplete = 'SmartIdentifyComplete',
  SmartLabelCreateLabel = 'SmartLabelCreateLabel',
  SmartLabelCreateCombinationLabel = 'SmartLabelCreateCombinationLabel',
  SmartPackageCreateTrackAndLinkDocuments = 'SmartPackageCreateTrackAndLinkDocuments',
  EasyDgdAdrDocument = 'EasyDgdAdrDocument',
  // [ActionTypeAggregation(EasyDgdAdrDocument)]
  EasyDgdRidDocument = 'EasyDgdRidDocument',
  // [ActionTypeAggregation(EasyDgdAdrDocument)]
  // [ActionTypeAggregation(EasyDgdRidDocument)]
  EasyDgdImoDocument = 'EasyDgdImoDocument',
  // [ActionTypeAggregation(EasyDgdAdrDocument)]
  // [ActionTypeAggregation(EasyDgdRidDocument)]
  // [ActionTypeAggregation(EasyDgdImoDocument)]
  EasyDgdAirDocument = 'EasyDgdAirDocument',
  AdrCheckCreatePackingList = 'AdrCheckCreatePackingList',
}
